import { useCallback } from "react";
import env from "../lib/env";

type trackingTypes =
  | "resource_selected"
  | "date_selected"
  | "time_selected"
  | "booking_confirmed";

export function usePixelTracker() {
  const trackEvent = useCallback(
    (type: trackingTypes, data: Record<string, any> = {}) => {
      if (!env.IS_PROD) {
        console.log(`[Tracking] ${type}:`, data);
      }

      // Facebook Pixel
      if (typeof window.fbq === "function") {
        window.fbq("trackCustom", type, data);
      }

      // Google Analytics (GA4)
      if (typeof window.gtag === "function") {
        window.gtag("event", type, {
          event_category: "Appointment",
          event_label: data.label || "",
          value: data.value || undefined,
          ...data,
        });
      }
    },
    []
  );

  return trackEvent;
}
